
import {
  getCategoryList,
} from "@/api/category-manage";
import { UPDATE_FILE_CLASS } from './mutationTypes';

let postData = {
  page_index: 1,
  page_size: 9999

  //获取七牛信息
};

export const getAllFileClass = async ({ commit }) => {
  const { status, data: { result: resData } } = await getCategoryList(postData);
  if (status === 200) {
    commit(UPDATE_FILE_CLASS, resData.data);
  }
}

